export const SankeyOrientation = {
  HORIZONTAL: 'horizontal',
  VERTICAL: 'vertical',
};

export const SankeyNodeAlign = {
  LEFT: 'left',
  RIGHT: 'right',
  JUSTIFY: 'justify',
  CENTER: 'center',
};

export const SankeyLinkFillStyle = {
  GRADIENT: 'gradient',
  SOLID: 'solid',
  SOURCE: 'source',
  TARGET: 'target',
};

export const SankeyDataField = {
  FROM: 'from',
  TO: 'to',
  VALUE: 'value',
};

export const SankeyTooltipText = {
  LINK_PREFIX: '{sourceId} → {targetId}\n',
  NODE: '{name}',
};

export const SankeyLabel = {
  // Cap node label width so long names (e.g. tracking URLs) truncate with an ellipsis instead of
  // overlapping neighbouring nodes. The full name stays available via the node tooltip.
  MAX_WIDTH: 500,
  // Cap and wrap the link tooltip so long "source → target" text stays readable.
  TOOLTIP_MAX_WIDTH: 500,
};

export const SankeyMaxNodes = {
  DEFAULT: 30,
  MIN: 10,
  MAX: 50,
};

export const OUTGOING_LINKS = 'outgoingLinks';
export const LABEL = 'label';
